import { ChainId } from 'goswap-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.KTOTEST]: '0x8f4479402fDA2060E21CF15158D788d910054C4E',
  [ChainId.KTOMAIN]: '0xE201bB4955C767765C8F996398d6a7e0c699B9Ff',
  [ChainId.NOSMAIN]: '0x9ea0B7C76495147921a89fb7436C6e7635D46604',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
